<template>
	<div  v-loading="loading" id="equitmentindex">
		<Header></Header>
		<TwiceTitle></TwiceTitle>
		<div class="container">
			<div class="class-box">
				<div class="class-list">
					<div class="name">影音分类：</div>
					<span v-for="(item ,index) in name" v-bind:key="item.index"
						  @click="companyTypeEvent(index,item.id)" ref="companyTypeDOM"
						  :class="index == 0? 'first-select' : 'select'">{{item.name}}</span>
				</div>
				<div style="padding-left:95px" class="class-list">
                <span v-for="(item ,index) in childrenCategory" v-bind:key="item.index"
					  @click="childrenCategoryEvent(index,item.id)" ref="eqchildrenCategoryEventDOM"
					  :class="index == 0? 'first-select' : 'select'">{{item.name}}</span>
				</div>
				<div class="class-list">
					<div class="name">品牌分类：</div>
					<span   v-for="(item,index) in brand" v-bind:key="item.index"
							@click="companyType(index,item.id)" ref="companyType"
							:class="index == 0? 'first-select' : 'select'">{{item.name}}</span>
				</div>
			</div>
			<div class='none'  v-if="list.length == 0">
				<img style="width:200px;height:250px" src="/static/image/null.svg" alt="">
				<div>非常抱歉！没有找到符合条件的商品!</div>
				<div style="font-size:14px;">您可以尝试：修改筛选条件或输入新的关键字重新查找</div>
			</div>
			<div class="containers">
				<div class="scale-pic" v-for="item in list" v-bind:key="item.id">
				<div class="more-pic">
					<router-link style="text-decoration:none;color:#444444;display:block;" :to="{ path: '/equitment/detail/'+item.id }" >
						<!--<div v-bind:style="{backgroundImage:'url('+item.cover_img+')'}" class="pic-box"></div>-->
						<div class="cover-pic">
							<div class="pic-box"  :style="{backgroundImage:item.cover_img}" ></div>
							</div>
						<div class="title">{{item.title}}</div>
					</router-link>
				</div>
				</div>
			</div>
			<div v-if="list.length != 0" class="pagination">
					<el-pagination
						background
						@current-change="changePage"
						:current-page="current_page"
						:page-size="12"
						layout="prev, pager, next"
						:total="total">
				</el-pagination>
				<span>共{{pagenum.last_page}}页</span>
			</div>
		</div>
		<Foot></Foot>
	</div>

</template>

<script>
	import {getBrandClass} from '@/api/equipmentStoreHouse/axios'
	import {getEquipmentList} from '@/api/equipmentStoreHouse/axios'
	import Foot from '@/components/common/Foot'
	import Header from '@/components/equitment/Header'
	import TwiceTitle from '@/components/equitment/TwiceTitle'
	import {tabSwitch} from '@/common/js/common'
	import Mixin from '@/common/js/mixin'
	export default {
		mixins: [Mixin],
		name: 'App',
		components:{
			Foot,
			Header,
			TwiceTitle
		},
		data (){
			return {
				brand:[],
				//搜索条件
				order:{
					brand:'',
					category:'',
				},
				name:[],
				list:[],
				key:'',
				childrenCategorys:[],//子分类 总集合
				childrenCategory:[],
				brand_id:'',//选中brand
				loading:true,
				total:0,
				current_page:0,
				page:1,
				pagenum:[],
			}
		},
		created () {
			this.getBrandClass()
			this.getEquipmentName()
			this.getEquipmentList()
		},
		methods:{
			getBrandClass: function () {
				getBrandClass ({}).then((response) =>{
					this.brand = response.data
					//头部推入全部选项
					this.brand.unshift({id:'',name:'全部',is_has_son:0});
				})
			},
			getEquipmentName: function () {
				let _this=this;
				this.$get('/apis/depot/depotCategory/parent/0').then((res)=>{
					if(res){
						this.name = res.data
						//头部推入全部选项
						this.name.unshift({id:'',is_has_son:0,name:'全部',parent_id:0,_children:[]});
						res.data.forEach(function(value,index){
							// 填充二级分类
							if(value._children.length !== 0){
								value._children.forEach(function(values,indexs){
									_this.childrenCategorys.push({id:values.id,name:values.name,pid:values.parent_id});
								})
							}
						});
					}
				})
			},
			companyTypeEvent(index,id) {
				let _this=this;
				tabSwitch(this,index,'companyTypeDOM');
				this.category = id
				//取子分类
				_this.childrenCategory=[];
				_this.childrenCategorys.forEach(function(value,index){
					if(id==value.pid){
						_this.childrenCategory.push({id:value.id,name:value.name,pid:value.parent_id});
					}
				})
				if(index!=0){
					//头部推入全部选项
					this.childrenCategory.unshift({id:id,is_has_son:0,name:'全部',parent_id:0,_children:[]});
				}
				this.category = id
				//二级分类变色
				this.childrenCategoryEvent(0,id)
			},
			childrenCategoryEvent(index,id){
				tabSwitch(this,index,'eqchildrenCategoryEventDOM');
				this.order.category = id
				this.getEquipmentList()
			},
			companyType(index,id) {
				this.brand_id=id;
				tabSwitch(this,index,'companyType');
				this.getEquipmentList()
			},
			getEquipmentList: function (value) {
				this.$get('/apis/depot/depot', {
					params: {
						brand:this.brand_id,
						key:this.keywords,
						category:this.order.category,
						order:'goods_hits desc',
						page:this.page,
					}
				}).then((res)=>{
					this.list = res.data.data
					this.loading = false
					// 分页参数
						this.pagenum=res.data
						this.total = res.data.total
						this.current_page = res.data.current_page
				})
			},
			changePage(currentPage){
				this.page = currentPage;
				this.getEquipmentList();
				document.body.scrollTop = document.documentElement.scrollTop = 0
			},
		},
		watch:{
			keywords:function(){
				this.page = 1
				this.getEquipmentList()
			}
		},
		computed: {
			keywords: function () {
				return this.$route.query.kw;
			}
		}
	}
</script>

<style >
	body{
		margin: 0px;
	}
	.scale-pic{
		margin-left: 20px
	}
	#equitmentindex{
		min-width: 1200px;
	}
	.el-submenu .el-menu{
		z-index: 1;
	}
	#equitmentindex .container{
		box-sizing: border-box;
		width: 1200px;
		margin: auto;
		min-height: 400px;
	}
	#equitmentindex .containers{
		overflow: hidden;
		width: 1200px;
		margin: auto;
		display: flex;
		flex-wrap: wrap;
		padding-top:10px;
	}
	#equitmentindex .class-box{
		background:  #fbfbfb;
		padding-bottom: 25px;
		margin-top: 10px;
	}
	.el-pagination.is-background .el-pager li.number:hover{
		color:#f9be04;
	}

	.el-pagination.is-background .el-pager li.active:hover{
		color:#fff;
	}

	#equitmentindex .class-list{
		display: flex;
	}
	#equitmentindex .name{
		margin-top: 25px;
		margin-left: 13px;
	}
	#equitmentindex .select{
		border: 1px solid #D3D3D2;
		border-radius: 8px;
		margin-top: 25px;
		padding: 0 12px;
		font-size: 12px;
		color: #D3D3D2;
		margin-left: 20px;
		cursor: pointer;
		height: 20px;
		line-height: 20px
	}
	#equitmentindex .first-select{
		border: 1px solid #F9BE04;
		border-radius: 8px;
		color: #F9BE04;
		margin-left: 20px;
		margin-top: 25px;
		padding: 0 12px;
		font-size: 12px;
		cursor: pointer;
		height: 20px;
		line-height: 20px;
	}
	#equitmentindex .search-money{
		margin-top: 25px;
		margin-left: 20px;
	}
	#equitmentindex .search-money input{
		border: 1px solid #d3d3d2;
		background: #EDEDED;
		width: 75px;
		height: 21px;
		font-size: 12px;
		text-align: center;
		border-radius: 2px;
	}
	#equitmentindex .search-money span{
		color: #d3d3d2
	}


    .cover-pic .pic-box:hover{
		transform: scale(1.1);
		transition: all .5s ease-out;
	}
	.cover-pic{
		overflow: hidden;
		height: 231px;
	}
	#equitmentindex .more-pic:hover{
		box-shadow: 0 0 2px 0 rgba(0,0,0,.12), 0 2px 2px 0 rgba(0,0,0,.12);
	}
	.cover-pic .pic-box{
			height: 231px;
			width: 260px;
	}
	#equitmentindex .more-pic .pic-box {
		transition: all .5s ease-out;
		transform-origin:center;
	}

	#equitmentindex .more-pic .title {
		transform-origin:center;
		font-size: 14px;
		color: #363636;
		line-height: 21px;
		margin-left:25px;
		text-align: center;
		transform-origin:center;
	}
	#equitmentindex .more-pic{
		float: left;
		width: 231px;
		height: 280px;
		margin-bottom: 20px;
		transform-origin:center;
	}
	.none{
		text-align: center;
		color: #555;
		font-size: 18px;
		margin: auto;
		min-height: 400px;
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		border: 1px solid #F9BE04;
		background: #F9BE04;

	}
	.el-pagination.is-background .el-pager li{
		border: 1px solid #D5D5D5;
		color: #D5D5D5;
	}
	 .pagination{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	 .pagination span{
		font-size: 14px;
		color: #D5D5D5;
		letter-spacing: 0;
		line-height: 18px;
		margin-left: 11px;
	}
	.pagination-button{
		color: #fff;
		background: #F9BE04;
		box-shadow: 0 2px 4px 0 rgba(200,200,200,0.50);
		border-radius: 2px 2px 2px 0 2px;
		border: none;
		height: 30px;
		width: 65px;
		margin-left: 8px;
	}
	
</style>



// WEBPACK FOOTER //
// src/components/equitment/Index.vue